/* @flow strict */

import * as React from 'react';
import CollapsedPanel from '/client/src/components/panel/collapsedPanel';
import SimpleSelect from '/client/src/components/forms/select';
import SimpleInput from '/client/src/components/forms/simpleInput';
// import _ from 'lodash';
import SimpleTextarea from '../../../../../components/forms/simpletextarea';

type PropsType = {
  facebookPage: {
    title: null | string,
    description: null | string,
    share_url_way: null | string,
    share_url: null | string
  },
  isSetSocialPromotions: boolean,
  imageUrl: string,
  handleControlFB: () => void,
  handleControlSocialPromotions: () => void
};

const FB = ({
  facebookPage,
  isSetSocialPromotions,
  imageUrl,
  handleControlFB,
  handleControlSocialPromotions,
  setValidateDataLength
}: PropsType): React.Element<typeof React.Element> => {
  const [title, setTitle] = React.useState(facebookPage.title || '');
  const [descr, setDescr] = React.useState(facebookPage.description || '');
  const [shareUrlWay, setShareUrlWay] = React.useState(facebookPage.share_url_way || 'EventUrl');
  const [shareUrl, setShareUrl] = React.useState(facebookPage.share_url || '');
  // const [isShowLimitLabel, toggleShowLimitLabel] = React.useState(false);
  // const [isShowLimitWarning, toggleShowLimitWarning] = React.useState(false);

  return (
    <CollapsedPanel
      status={isSetSocialPromotions}
      title='Customize Facebook Post'
      onChange={(status: boolean): any => handleControlSocialPromotions(status)}
    >
      <div className="row">
        <div className="col-md-6">
          <SimpleSelect
            label='Share URL'
            value={shareUrlWay}
            items={[
              {
                label: 'event url',
                value: 'EventUrl'
              },
              {
                label: 'custom url',
                value: 'CustomUrl'
              }
            ]}
            callBack={(e: any) => {
              setShareUrlWay(e.target.value);
            }}
            onBlur={(e: any) => {
              handleControlFB('share_url_way', e.target.value);
            }}
          />
          {shareUrlWay === 'CustomUrl' &&
            <SimpleInput
              name={'fbShareUrl'}
              id={'fbShareUrl'}
              label='Facebook Share URL'
              value={shareUrl}
              onChange={(e: any) => {
                setShareUrl(e.target.value);
              }}
              onBlur={() => {
                handleControlFB('share_url', shareUrl);
              }}
            />
          }

          <SimpleInput
            name={'fbTitle'}
            id={'fbTitle'}
            label='Title of Post'
            value={title}
            onChange={(e: any) => {
              setTitle(e.target.value);
            }}
            onBlur={() => {
              handleControlFB('title', title);
            }}
            validator={{}}
            maxLength={50}
            isShowLimit
            limit={50}
            limitCb={setValidateDataLength}
          />

          <div className="form-group SimpleInput">
            <SimpleTextarea
              label={'Description of Post'}
              name={'fbDesc'}
              id={'fbDesc'}
              value={descr}
              onChange={(e: any) => {
                setDescr(e.target.value);
                // toggleShowLimitWarning(_.size(e.target.value) > 250);
              }}
              onBlur={() => {
                handleControlFB('description', descr);
                // toggleShowLimitLabel(false);
              }}
              // onFocus={() => {
                // toggleShowLimitLabel(true);
              // }}
              maxLength={250}
              rows={6}
              isShowLimit
              limitCb
            />
          </div>
        </div>

        <div className="col-md-6">
          <div className="fb-og-page">
            <div className="fb-og-page-image">
              <div className="fb-og-page-img"
                style={{
                  backgroundImage: `url("${imageUrl}?maxwidth=3200&maxheight=3200&crop=(0%2C0%2C0%2C0)&width=640)`
                }}
              />
            </div>

            <div className="fb-og-page-info">
              <div className="fb-og-page-title">
                {title}
              </div>

              <div className="fb-og-page-desc">
                {descr}
              </div>

              <div className="fb-og-page-url">
                E.SPARXO.COM
              </div>
            </div>
          </div>
        </div>
      </div>
    </CollapsedPanel>
  );
};

export default FB;
